function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.9991 1.46323C14.0069 1.34336 13.9648 1.2256 13.8828 1.13786C13.8007 1.05012 13.6861 1.00022 13.566 1H1.43408C1.31391 1.00005 1.19913 1.0499 1.11706 1.13768C1.03499 1.22546 0.992956 1.34332 1.00097 1.46323C1.21025 4.37736 3.33356 6.79601 6.19604 7.38093V13.0989C6.1961 13.2673 6.29358 13.4206 6.44614 13.492C6.5987 13.5634 6.77881 13.5402 6.90825 13.4324L8.64534 11.9848C8.74449 11.9024 8.8018 11.7802 8.80168 11.6513V7.38093C11.6652 6.7971 13.7897 4.37813 13.9991 1.46323Z",
  stroke: "#818181",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgFilterIcon = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter-icon.71ed738e.svg";
export { ForwardRef as ReactComponent };